module.exports = __webpack_public_path__ + "img/Cookie_1_resize_13.76e9300d.png";